
import { Navigation } from "@/components/Navigation";
import { BraceletRegistration } from "@/components/BraceletRegistration";
import { useEffect, useState } from "react";
import { DailyVerse } from "@/components/DailyVerse";
import { useSession } from "@supabase/auth-helpers-react";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";

const Home = () => {
  const [loading, setLoading] = useState(true);
  const session = useSession();
  const navigate = useNavigate();
  const { toast } = useToast();

  // Handle successful authentication
  useEffect(() => {
    async function handleLoggedInUser() {
      if (!session?.user?.id) return;
      
      console.log("User signed in successfully, checking profile...");
      
      try {
        // Get user profile
        const { data: profile, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', session.user.id)
          .maybeSingle();
          
        if (error) {
          console.error("Error loading profile:", error);
          return;
        }
        
        console.log("Profile loaded:", profile);
        
        // Check if user is admin
        const { data: adminRole, error: adminError } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', session.user.id)
          .eq('role', 'admin')
          .maybeSingle();
          
        if (adminError) {
          console.error("Error checking admin status:", adminError);
        }
        
        // If user is admin, enable admin view and redirect to admin dashboard
        if (adminRole) {
          console.log("Admin user detected, enabling admin view and redirecting to admin dashboard");
          window.sessionStorage.setItem('adminViewEnabled', 'true');
          toast({
            title: "Admin Login Detected",
            description: "Redirecting to admin dashboard",
          });
          navigate('/admin/users');
          return;
        }
        
        if (profile?.onboarded) {
          console.log("Existing user, redirecting to community");
          navigate('/graceful-petitions');
        }
        
      } catch (error) {
        console.error("Error in auth flow:", error);
      } finally {
        setLoading(false);
      }
    }

    handleLoggedInUser();
  }, [session, navigate, toast]);

  return (
    <div className="min-h-screen bg-background">
      <div className="container py-8 pb-24">
        <div className="flex flex-col items-center mb-8">
          <img
            src="/lovable-uploads/63dc6fcc-849b-4d08-a3d0-a0fa7dfa124d.png"
            alt="Grace Awakens Logo"
            className="w-32 h-32 mb-4"
            loading="eager"
          />
        </div>
        <DailyVerse />
        <BraceletRegistration />
      </div>
      <Navigation />
    </div>
  );
};

export default Home;
